import { createContext, useState } from "react";

//const ALERT_TIME = 20000;
const initialState = {
  title:"",
  text: "",
  desc: "",
  searchWords: "",
  type: "",
  isRetryEnabled: "",
  buttonClicked:"",
};

const AlertContext = createContext({
  ...initialState,
  setAlert: () => {},
  setBackButtonClicked: () => {},
  setBackButtonUnclicked: () => {},
});

export const AlertProvider = ({ children }) => {
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [searchWords, setSearchWords] = useState("");
  const [type, setType] = useState("");
  const [yesButton, setyesButton] = useState(false);
  const [noButton, setnoButton] = useState(false);
  const [isRetryEnabled, setRetryEnabled] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(()=>{});
  const [goBack, setGoBack] = useState(false);

  const setAlert = (title, text, desc, searchWords, type, yes, no, isRetryEnabled, buttonClicked) => {
    setTitle(title);
    setText(text);
    setType(type);
    setDesc(desc);
    setyesButton(yes);
    setnoButton(no);
    setSearchWords(searchWords);
    setRetryEnabled(isRetryEnabled);
    setButtonClicked(()=>{
      return buttonClicked;
    });

    // setTimeout(() => {
    //   setTitle("");
    //   setText("");
    //   setType("");
    //   setDesc("");
    //   setSearchWords("");
    //   setRetryEnabled("");     
    // }, ALERT_TIME);
  };
  const setBackButtonClicked = () =>{
    setGoBack(true)
  }

  const setBackButtonUnclicked = () =>{
    setGoBack(false)
  }

  const destroyAlert = () => {
    setTimeout(() => {
      setTitle("");
      setText("");
      setType("");
      setDesc("");
      setyesButton("");
      setnoButton("");
      setSearchWords(""); 
      setRetryEnabled("");
    }, 0);
  };

  return (
    <AlertContext.Provider
      value={{
        title,
        text,
        desc,
        searchWords,
        type,
        setAlert,
        buttonClicked,
        destroyAlert,
        yesButton,
        noButton,
        isRetryEnabled,
        setBackButtonClicked,
        goBack,
        setBackButtonUnclicked,
      }}
    > 
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContext;